import AddressFormController from './address-form-controller'

export default AddressFormController
